<template>
    <div class="page-container">
        <!--工具栏-->
        <el-scrollbar>
        <el-form :inline="true" :model="filters" class="demo-form-inline toolbar" style="padding-bottom:0px;" :size="size">
            <el-form-item label="长者姓名">
                <el-input
                    v-model.trim="filters.oldName"
                    auto-complete="off"
                    placeholder="请输入名字"
                ></el-input>
            </el-form-item>
            <el-form-item>
                <kt-button icon="el-icon-search" label="查询" type="primary" @click="findList()"/>
            </el-form-item>
            <el-form-item>
                <kt-button icon="el-icon-plus" label="下单" type="warning" @click="handleAdd"/>
            </el-form-item>
        </el-form>
        </el-scrollbar>
        <!--表格内容栏-->
        <kt-table
            v-loading="loading"
            element-loading-text="拼命加载中"
            :data="pageResult"
            :columns="filterColumns"
            :showDelete="false"
            :showEdit="false"
            :operationWidth="280"
            :showLook="false"
            :showOperation="false"
            @findPage="findPage"
            @refreshPageRequest="refreshPageRequest"
        >
        </kt-table>

        <el-dialog
            title="购买套餐"
            width="300px"
            :visible.sync="addDialogVisible"
            :close-on-click-modal="false"
        >
            <el-form :model="addPackageForm"
                label-width="100px">
                  <el-row>
                    <el-form-item label="套餐选择:" prop="packageId">
                      <el-select v-model="addPackageForm.packageId" 
                        style="width: 100%" placeholder="请选择套餐">
                        <el-option
                            v-for="item in packageList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                        ></el-option>
                    </el-select>
                    </el-form-item>
                  </el-row>
                  <el-row>
                    <el-form-item label="长者姓名:" prop="oldmanName">
                      <el-autocomplete
                          v-model.trim="addPackageForm.oldmanName"
                          auto-complete="off"
                          placeholder="请输入长者姓名"
                          style="width: 100%"
                          :fetch-suggestions="querySearchAsync"
                          @select="handleOlderSelect"
                        ></el-autocomplete>
                    </el-form-item>
                  </el-row>
                  <el-row>
                    <el-form-item label="购买方式:" prop="type">
                        <el-select v-model="addPackageForm.type" 
                            style="width: 100%" clearable placeholder="请选择购买方式">
                            <el-option
                                v-for="item in shopTypeOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                  </el-row>
            </el-form>
           
            <div slot="footer" class="dialog-footer" align="center">
                <el-button :size="size" @click.native="addDialogVisible = false"
                  >取消</el-button
                >
                <el-button
                  :size="size"
                  type="primary"
                  @click.native="submitAddForm"
                  >确定</el-button
                >
              </div>
        </el-dialog>
    </div>
</template>
<script>
import KtTable from "@/components/KtTable";
import KtButton from "@/components/KtButton";
export default {
    components: {
        KtTable,
        KtButton
    },
    data() {
        return {
            loading: true,
            shopTypeOptions: [],
            size: "medium",
            filters: {
                oldName: "",
                pageNum: 1, 
                pageSize: 10
            },
            filterColumns:[],
            pageResult: {},
            packageList:[],
            addPackageForm:{},
            addDialogVisible:false,
            serviceList:[],
            oldmanList:[],
            oldManId:'',
        };
    },
    methods: {
        findPage(data){
            console.log(data);
        },
        refreshPageRequest(data){
            console.log(data);
        },
        findList() {
            //判断查询条件是否存在
            this.$postJson("omc/servicePackage/packageRecordShow",this.filters).then(res => {
                res.result.list.forEach(item =>{
                    if(item.type == 0){
                        item.type = '现金支付';
                    }else if(item.type == 1){
                        item.type = '老年卡支付';
                    }else if(item.type == 2){
                        item.type = '银行卡支付';
                    }else if(item.type == 3){
                        item.type = '支付宝微信支付';
                    }else{
                        item.type = '其他方式';
                    }
                })
            this.pageResult = res.result;
            setTimeout(() => {
                this.loading = false;
            }, 500);
            });
        },
        /* 
        模糊查询老人
        */
        querySearchAsync(queryString, cb) {
          let param = {
            oldName: queryString
          };
          this.$postJson("omc/Oldman/quickShowAllOldMan", param).then((res) => {
            this.oldmanList = res.result.list;
            var list = [{}];
            if (res.result.list.length > 0) {
              for (let i of res.result.list) {
                i.value = i.oldName; //将想要展示的数据作为value
              }
              list = res.result.list;
              this.oldManId = null;
              cb(list);
            } else {
              let arr = [];
              arr.push({
                uuid: "-1",
                value: "",
              });
              cb(arr);
            }
          });
        },
          /* 
          根据模糊查询老人返回老人id
        */
        handleOlderSelect(item) {
          this.oldManId = item.oldmanId;
        },

        // 时间格式化
        dateFormat(row, column, cellValue, index) {
            return format(row[column.property]);
        },
        
        // 跳转新增界面
        handleAdd() {
            this.addDialogVisible = true;
            this.addPackageForm = {
                packageId:'',
                oldmanId:'',
                oldmanName:'',
                type:'',
                name:'',
                fee:0,
            };
        },
        submitAddForm(){
            console.log(this.addPackageForm);
            if(this.addPackageForm.packageId == ''){
                this.$message({
                    message: "请选择套餐",
                    type: "error",
                });
                return;
            }
            if(this.oldManId == ''){
                this.$message({
                    message: "请选择购买人",
                    type: "error",
                });
                return;
            }
            if(this.addPackageForm.type === ''){
                this.$message({
                    message: "请选择购买方式",
                    type: "error",
                });
                return;
            }
            let packageItem = {};
            this.packageList.forEach(item =>{
                if(item.id == this.addPackageForm.packageId){
                    packageItem = item
                }
            })
            var params = {
                packageId:this.addPackageForm.packageId,
                oldmanId:this.oldManId,
                oldmanName:this.addPackageForm.oldmanName,
                type:this.addPackageForm.type,
                name:packageItem.name,
                fee:packageItem.price
            }
            console.log(params);
            this.$postJson("omc/servicePackage/shopPackage", params).then(res =>{
                this.addDialogVisible = false;  
                if(res.code == 200){
                    this.findList();
                }
            })

        },
        //初始化服务类型
        initialShopTypes() {
            var serviceTypes = ["现金支付", "老年卡支付", "银行卡支付", "支付宝微信支付", "其他方式"];
            for (var i = 0; i < serviceTypes.length; i++) {
                var item = {};
                item.value = i;
                item.label = serviceTypes[i];
                this.shopTypeOptions.push(item);
            }
        },
        initColumns() {
            var columns = [
                { prop: "name", label: "套餐名称", minWidth: 130 },
                { prop: "fee", label: "套餐价格", minWidth: 130 },
                { prop: "oldmanName", label: "购买人", minWidth: 130 },
                { prop: "type", label: "购买方式", minWidth: 130},
                // { prop: "remark", label: "备注", minWidth: 150 },
                { prop: "creator", label: "操作人员", minWidth: 120 },
                { prop: "createdTime",label: "购买时间",minWidth: 120,formatter: this.dateFormat}
            ];
            this.filterColumns = JSON.parse(JSON.stringify(columns));
        },
        initPackageList(){
            this.$postJson("omc/servicePackage/packageList").then(res => {
                
                this.packageList = res.result;
            });
        },
    },
    mounted() {
        this.initialShopTypes();
        this.initColumns();
        this.initPackageList();
        this.findList();
    }
};
</script>
<style lang="scss" scoped>
    .avatar-uploader {
        width: 150px;
        height: 150px;
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .avatar-uploader:hover {
        border-color: #409eff;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 150px;
        height: 150px;
        line-height: 150px;
        text-align: center;
    }
    .avatar {
        width: 150px;
        height: 150px;
        display: block;
    }
    // ::v-deep深度作用选择符
    ::v-deep .el-dialog__header {
        text-align: left;
        background: rgb(238, 231, 231);
        border-bottom: 2px solid rgb(211, 207, 207);
    }
    //新增 编辑 dialog
    @media screen and (max-width: 1599px) {
        ::v-deep .volunteerdialog .el-dialog {
            width: 60% !important;
        }
    }
    ::v-deep .el-scrollbar .el-scrollbar__wrap .el-scrollbar__view{
        white-space: nowrap;
        width:100.5%;
        height:100%;
    }
    ::v-deep .el-form--inline{
        position: relative;
        z-index: 99;
    }
    .filtersposition{
        position: absolute;
        top:10px;
        left:0;
        right:0;
        bottom:10px;
        width:100%;
        height:56px;
        background: #F2F2F2;
        z-index:1;
    }
</style>